<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.beneficiaries") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" :to="{ name: 'create-beneficiaries' }">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="20"
      :loading="tableLoading"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-sm-center">
            {{ item.name ? item.name : "No Name Found" }}
          </td>
          <td class="text-sm-center">
            {{ item.birth_date ? item.birth_date : "----" }}
          </td>
          <td class="text-sm-center">
            {{ item.gender === 1 ? $t("male") : $t("female") }}
          </td>
          <td class="text-sm-center">
            {{ item.beneficiary_number }}
          </td>

          <td class="text-sm-center">
            <v-btn
              icon
              :to="{
                name: 'edit-beneficiaries',
                params: { id: item.id },
              }"
            >
              <v-icon small title="edit"> mdi-pencil</v-icon>
            </v-btn>
            <v-icon small title="delete" @click="handleDelete(item, index)">
              mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- table -->
    <!-- Pagination -->
    <div class="text-xs-center pt-2">
      <v-pagination
        v-if="pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="handlePagination"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
export default {
  name: "Memebers",

  data() {
    return {
      slug: "",
      pagination: [],
      headers: [],
      items: [],
      tableLoading: true,
      isEdit: false,
      itemIndex: "",
    };
  },

  mounted() {
    this.createTableHeaders();
  },
  methods: {
    handleDelete({ id }, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteData({ reqName: "beneficiaries", param: id })
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    createTableHeaders() {
      const headersList = [
        "name",
        "birth_date",
        "gender",
        "beneficiary_number",
        "actions",
      ];
      this.headers = TableHeaders(headersList);
    },
    handleGetData(query) {
      IndexData({ reqName: "beneficiaries", query })
        .then((res) => {
          const { data } = res.data;
          this.items = data;
          this.pagination = res.data.meta;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handlePagination(page) {
      this.$router.replace({ query: { ...this.$route.query, page: page } });
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        this.handleGetData(query);
      },
      immediate: true,
    },
  },
};
</script>
